import decoderWorkerCode from './decoder-worker'


export default class H264Decoder {

  worker_ = null
  width_ = 0
  height_ = 0
  isInitialized_ = false
  
  onInitialized: Function = null
  onReceiveRGBA: Function = null
  onReceiveYUV: Function = null
  
  workerCallback = (evt) => {
    var status = evt.data.status

    switch (status) {
      case 'INITIALIZED':
        this.isInitialized_ = true
        this.width_ = evt.data.width
        this.height_ = evt.data.height
        if (this.onInitialized) {
          this.onInitialized(this.width_, this.height_)
        }
        break
      case 'RGBA_FRAME':
        if (this.onReceiveRGBA) {
          this.onReceiveRGBA(this.width_, this.height_, evt.data.payload)
        }
        break
      case 'YUV_FRAME':
        if (this.onReceiveYUV) {
          this.onReceiveYUV(this.width_, this.height_, evt.data.payload)
        }
        break
    }
  }

  

  restartWorker = () => {
		this.stopWorker()
		
    var blob = new Blob([decoderWorkerCode])
		var blobURL = URL.createObjectURL(blob)
		this.worker_ = new Worker(blobURL)

    this.width_ = 0
    this.height_ = 0
    this.isInitialized_ = false
    this.worker_.onmessage = this.workerCallback

  }
	
	stopWorker = () => {
		if (this.worker_) {
			this.worker_.postMessage({ command: 'CLOSE' })
			this.worker_ = undefined
		}
	}

  feed = (nalu, command?) => {
    command = command || 'RECV_YUV'
    var uint8Array = new Uint8Array(nalu.length)
    uint8Array.set(nalu)
    var data = uint8Array.buffer
    this.worker_.postMessage({ command: command, payload: data }, [data])
  }


  isInitialized = () => {
    return this.isInitialized_
  }

};


// WEBPACK FOOTER //
// ./base/vsweb-h264-decoder.ts